import { QuotationsType } from 'containers/OutWorkbench/utils';

export const isAdsXiaohao = (detail: any) => {
  const { project_plan_info = {} } = detail;
  return project_plan_info.ad_settle_way === QuotationsType.XIAOHAO;
};
